import { useState, useRef } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"

import ActionButton from "../Form/ActionButton"
import OutsideClickHandler from "../OutsideClickHandler"

import NonModalDialogDropdown from "./NonModalDialogDropdown"

/**
  Component which shows a dropdown when clicked
  This dropdown can be composed of multiple options
  e.g. Room/Guests selection in hotel search
*/

function NonModalDialog(props) {
  const {
    ariaLabel,
    ariaDescribedBy,
    className,
    id,
    button,
    closeLabel,
    closeAriaLabel,
    dialogAriaLabel,
    children
  } = props

  const [isOpen, setIsOpen] = useState(false)

  const buttonRef = useRef(null)

  const handleToggleDialog = () => setIsOpen(!isOpen)
  const handleCloseDialog = () => setIsOpen(false)
  const handleCloseAndFocus = () => {
    handleCloseDialog()
    if (buttonRef?.current) {
      buttonRef.current.focus()
    }
  }

  const callChildren = typeof children === "function"

  return (
    <div className={classNames("oj-non-modal-dialog", className, { expanded: isOpen })} id={id}>
      <OutsideClickHandler
        disabled={!isOpen}
        ignoreRef={buttonRef}
        onOutsideClick={handleCloseDialog}
      >
        <button
          type="button"
          ref={buttonRef}
          className={classNames("show-dialog-button", { expanded: isOpen })}
          aria-pressed={isOpen}
          aria-label={ariaLabel}
          aria-describedby={ariaDescribedBy}
          onClick={handleToggleDialog}
        >
          {button}
        </button>
        {isOpen && (
          <NonModalDialogDropdown onEscape={handleCloseAndFocus} ariaLabel={dialogAriaLabel}>
            {callChildren ? children(handleCloseDialog) : children}
            {closeLabel && (
              <ActionButton
                className="done-row"
                onClick={handleCloseAndFocus}
                accessibilityText={closeAriaLabel}
              >
                {closeLabel}
              </ActionButton>
            )}
          </NonModalDialogDropdown>
        )}
      </OutsideClickHandler>
    </div>
  )
}

NonModalDialog.propTypes = {
  ariaDescribedBy: PropTypes.string,
  ariaLabel: PropTypes.string,
  button: PropTypes.node.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.string,
  closeAriaLabel: PropTypes.node,
  closeLabel: PropTypes.node,
  dialogAriaLabel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
}

export default NonModalDialog
